export default "__VITE_ASSET__CpOF6Afb__"